import {useState, useRef, useEffect} from 'react';
import {CSSTransition} from 'react-transition-group';

import './Sidebar.css';

// This is the javascript for the side nav bar once you go to a small screen
const Sidebar = ({isOpen = false, overlay = true, className = '', onClose, children}) => {
    const overlayRef = useRef(null);
    const sidebarRef = useRef(null);
    const [openNav, setOpenNav] = useState(isOpen);

    useEffect(() => {
        setOpenNav(isOpen);
    }, [isOpen]);

    const handleCloseNav = () => {
        setOpenNav(false);
        if (onClose) {
            onClose();
        }
    }
// CSS Transition makes the sidebar *slide* out rather than magically appear
    return (
        <>
            <CSSTransition
                in={openNav && overlay}
                nodeRef={overlayRef}
                timeout={500}
                classNames="mobile-nav-overlay"
                unmountOnExit
            >
                <div ref={overlayRef}
                     className="mobile-nav-overlay"
                     onClick={handleCloseNav}
                ></div>
            </CSSTransition>
            <CSSTransition
                in={openNav}
                nodeRef={sidebarRef}
                timeout={500}
                classNames="mobile-nav"
                unmountOnExit
                // onEnter={() => setShowButton(false)}
                // onExited={() => setShowButton(true)}
            >
                <aside className={`mobile-nav ${className}`} ref={sidebarRef}>
                    {children}
                </aside>
            </CSSTransition>
        </>
    )
}

export default Sidebar;